import React from 'react'
import {Icone, Progress, View} from 'react-template'
import {confirmarEmail} from './Actions'
import {formatLongToDateHM} from '../../../helpers/Data'
import "../../../assets/css/view/formulario/confirmacao/ConfirmarEmail.css"
export default class ConfirmarEmail extends View {

    constructor(props){
        super(props)

        this.state = {
            statusLoader: null,
            formTitulo: null,
            dataConfirmacao: null,
            messageError: null
        }

    }

    componentDidMount(){
        this.setState({statusLoader: true})
        confirmarEmail(this.props.params.cod, res => {
            this.setState({statusLoader: false, formTitulo: res.data.formTitulo, dataConfirmacao: res.data.dataConfirmacao})
        }, error => {
            this.setState({statusLoader: false, messageError: error.response.data})
            // this.notifyError("Erro", error)
        })
    }

    getConfirmacao(){
        
        if(this.state.statusLoader === null) return

        if(this.state.formTitulo){
            return (
                <div className="sucesso">
                    <Icone icone='check-circle' tamanho="2" fontAwesome/>
                    <h3>Obrigado por confirmar seu email.</h3>
                    <p>
                        Sua inscrição em: <b>{this.state.formTitulo}</b> esta aprovada. 
                        <br/>
                        Data de Confirmação: <b>{formatLongToDateHM(this.state.dataConfirmacao)}</b>
                    </p>
                </div>
            )
        }
        if(this.state.formTitulo === null && this.state.statusLoader === false){
            return (
                <div className="erro">
                    <Icone icone='times-circle' tamanho="2" fontAwesome/>
                    <h3>Não foi possível confirmar seu email.</h3>
                    <p>{this.state.messageError}</p>
                </div>
            )
        }
    }

    getProgress(){
        if(this.state.statusLoader === null || this.state.statusLoader){
            return (
                <Progress position={'top'}/>
            )
        }
    }

    render() {
        return (
            <div className="confirmar-email">
                {this.getProgress()}
                {this.getConfirmacao()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/view/formulario/confirmacao/ConfirmarEmail.js